import { Controller } from "stimulus";
import getValueFromLocalStorage from "../../functions/getValueFromLocalStorage";
import updateValueInLocalStorage from "../../functions/updateValueInLocalStorage";

export default class extends Controller {
  static get targets() {
    return ["mnemonic"];
  }

  connect() {
    if (this.strategy === "instant") {
      this.populateMnemonicField();
    }
  }

  populateMnemonicField() {
    this.mnemonicTarget.value = getValueFromLocalStorage(this.mnemonicKey);
  }

  updateLocalStorage() {
    updateValueInLocalStorage(this.mnemonicKey, this.mnemonicTarget.value);
  }

  get strategy() {
    return this.element.dataset.strategy;
  }

  get mnemonicKey() {
    return this.element.dataset.mnemonicKey;
  }
}
